import React from 'react';
import { Box, InfoBanner, Text } from '@sparknz/spark-pattern-library';

import { EligibilityCount } from 'components/shop/MobilePlans/typings/plans';
import { removePrices } from 'components/shop/MobilePlans/utils/removePrices.utils';

interface EligibilityInfoBannerProps {
  planName: string;
  eligibilityCount: EligibilityCount;
}

const EligibilityInfoBanner = ({
  planName,
  eligibilityCount,
}: EligibilityInfoBannerProps) => {
  const { available, maximum } = eligibilityCount;

  const availableCount = available ?? 0;
  const maximumCount = maximum ?? 0;
  const usedCount = maximumCount - availableCount;

  const formattedPlanName = removePrices(`${planName}s`);
  const message = `You currently have ${usedCount} ${formattedPlanName} on your account. You can add up to ${availableCount} more, for a total of ${maximumCount} ${formattedPlanName}.`;

  return (
    <Box mb="s4">
      <InfoBanner variant="INFO">
        <Text variant="bodySMedium">{message}</Text>
      </InfoBanner>
    </Box>
  );
};

export default EligibilityInfoBanner;
